import { MOCK_API_URL } from 'consts';

const mockApiUrl = (str: TemplateStringsArray) => `${MOCK_API_URL}/${str}`;

export default mockApiUrl;
